export const localStorageKeys = {
  ACCESS_TOKEN: 'auti:accessToken',
  DONT_SHOW_LIVE_MESSAGE_AGAIN: 'util:dontShowLiveMessageAgain',
  DONT_SHOW_RAFFLE_MODAL_AGAIN: 'util:dontShowRaffleModalAgain',
  DASHBOARD_MODAL: 'util:dashModal',
  WHITELABEL: 'start:whitelabel',
}
